var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconcrown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "#f3123c",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.074,5.463a1.981,1.981,0,0,0-2.482-.05l-9.28,6.927L23.758.99a2.05,2.05,0,0,0-3.509,0L12.69,12.34,3.408,5.41a1.984,1.984,0,0,0-2.482.052,2.679,2.679,0,0,0-.86,2.645L4.4,27.81V37.5A2.365,2.365,0,0,0,6.6,40H37.4a2.365,2.365,0,0,0,2.2-2.5V27.81l4.334-19.7A2.679,2.679,0,0,0,43.074,5.463ZM10.272,16.52A4.072,4.072,0,0,0,16.2,15.357L22,6.642l5.8,8.715a4.075,4.075,0,0,0,5.927,1.16l4.569-3.41L35.682,25H8.318L5.7,13.1ZM35.2,35H8.8V30H35.2Z",
    transform: "translate(2 4)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconcrown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconcrown.c25b5eab.svg";
export { ForwardRef as ReactComponent };